import { css } from "@emotion/react";

import * as dimensions from "@styles/emotion-styles/dimensions";

export const form = css`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 1.5rem auto;
`;

export const email = css`
  max-width: 26rem;
  margin-bottom: 1.5rem;

  @media (max-width: ${dimensions.phone}) {
    max-width: 100%;
  }
`;
